const calendarErrors = Object.freeze({
    nameAlreadyExists: 151
});

export default calendarErrors;
